"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const FractureSizeButton_1 = __importDefault(require("../../atoms/FractureSizeButton"));
const ui_1 = require("@completeanatomy/ui");
const FractureSizes_1 = __importDefault(require("../FractureSizes"));
const sizes = [3, 2, 1, 0];
function FractureOptionsPanel({ className, size, onSizeChange, }) {
    const [isActive, toggleActive] = (0, ui_1.useToggleState)(false);
    const containerRef = (0, react_1.useRef)(null);
    const onClickOutside = () => {
        toggleActive();
    };
    (0, ui_1.useOutsideClick)(containerRef, onClickOutside, [], {
        active: isActive,
        stopPropagation: true,
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Overlay, { shown: isActive, zIndex: 0, "data-e2e": 'FractureOptionsPanel_Overlay' }), (0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, "data-e2e": 'FractureOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(SizesContainer, { active: isActive, sizes: sizes, size: size, onChange: onSizeChange, "data-e2e": 'FractureOptionsPanel_SizesContainer' }), (0, jsx_runtime_1.jsx)(FractureSizeButton_1.default, { active: isActive, size: size, onClick: toggleActive, "data-e2e": 'FractureOptionsPanel_FractureSizeButton' })] })] }));
}
exports.default = FractureOptionsPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
`;
const SizesContainer = (0, styled_components_1.default)(FractureSizes_1.default) `
  position: absolute;
  top: 0;
  left: 0;

  padding-left: 70px;
`;
